import strFunc from "@/lib/lyg/string";

function SumDivArea(props: any) {
  let myProps = {
    order_book_arr: [],
    stu_info_arr: [],
    is_order_online: false,
    ...props
  };
  let order_book_arr = myProps.order_book_arr;
  let order_book_amount = 0;
  let total_price = 0;
  let each_price = 0;
  let each_book_amount = order_book_arr.length;

  for (let i = 0; i < order_book_arr.length; i++) {
    let book_info = order_book_arr[i];
    let product_info = book_info["product_info"];
    if (myProps.is_order_online) {
      product_info = book_info["product_info_use"];
    }
    if (product_info) {
      let product_price = parseInt(strFunc.uncomma(product_info["a_price"]));
      product_price += parseInt(strFunc.uncomma(product_info["a_price_tax"]));
      each_price += product_price;
    }
  }

  for (let stu_i = 0; stu_i < myProps.stu_info_arr.length; stu_i++) {
    order_book_amount += order_book_arr.length;

    for (let i = 0; i < order_book_arr.length; i++) {
      let book_info = order_book_arr[i];
      let product_info = book_info["product_info"];
      if (myProps.is_order_online) {
        product_info = book_info["product_info_use"];
      }
      if (product_info) {
        let product_price = parseInt(strFunc.uncomma(product_info["a_price"]));
        product_price += parseInt(strFunc.uncomma(product_info["a_price_tax"]));
        total_price += product_price;
      }
    }
  }

  return (
    <div style={{ padding: "16px", background: "#f8f9fa", borderRadius: "8px" }}>
      <table style={{ width: "100%", borderCollapse: "separate", borderSpacing: "0 8px" }}>
        <colgroup>
          <col style={{ width: "35%" }}></col>
          <col style={{ width: "65%" }}></col>
        </colgroup>
        <tbody>
          <tr>
            <td style={{
              background: "#fff",
              padding: "12px 16px",
              fontWeight: "600",
              borderRadius: "6px 0 0 6px",
              borderLeft: "3px solid #6c757d"
            }}>
              학생
            </td>
            <td style={{
              background: "#fff",
              padding: "12px 16px",
              textAlign: "right",
              fontSize: "16px",
              borderRadius: "0 6px 6px 0"
            }}>
              <strong>{myProps.stu_info_arr.length}</strong> 명
            </td>
          </tr>
          <tr>
            <td style={{
              background: "#fff",
              padding: "12px 16px",
              fontWeight: "600",
              borderRadius: "6px 0 0 6px",
              borderLeft: "3px solid #0d6efd"
            }}>
              수량
            </td>
            <td style={{
              background: "#fff",
              padding: "12px 16px",
              textAlign: "right",
              borderRadius: "0 6px 6px 0"
            }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "8px" }}>
                <span style={{ color: "#6c757d" }}>
                  ({strFunc.comma(each_book_amount)}개 × {myProps.stu_info_arr.length}명)
                </span>
                <span style={{ fontSize: "20px", fontWeight: "700", color: "#0d6efd" }}>
                  {order_book_amount}개
                </span>
              </div>
            </td>
          </tr>
          <tr>
            <td style={{
              background: "#fff",
              padding: "14px 16px",
              fontWeight: "700",
              fontSize: "16px",
              borderRadius: "6px 0 0 6px",
              borderLeft: "4px solid #dc3545"
            }}>
              총 금액
            </td>
            <td style={{
              background: "#fff",
              padding: "14px 16px",
              textAlign: "right",
              borderRadius: "0 6px 6px 0"
            }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "8px" }}>
                <span style={{ color: "#6c757d" }}>
                  ({strFunc.comma(each_price)}원 × {myProps.stu_info_arr.length}명)
                </span>
                <span style={{ fontSize: "22px", fontWeight: "700", color: "#dc3545" }}>
                  {strFunc.comma(total_price)}원
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
export default SumDivArea;